import { createSlice } from '@reduxjs/toolkit';

const defaultState = {
    page: 0,
    size: 10,
    sortByField: '',
    sortingDirection: 'ASC',
};

const PaginationSlice = createSlice({
    name: 'pagination',
    initialState: defaultState,
    reducers: {
        setPage(state, { payload }) {
            state.page = payload;
        },
        setDirection(state, { payload }) {
            state.sortingDirection = payload;
        },
        setSortField(state, { payload }) {
            state.sortByField = payload;
        },
    },
});

export default PaginationSlice.reducer;
export const { setPage, setDirection, setSortField } = PaginationSlice.actions;
